<template>
    <div>
        <div class="my-3 d-flex justify-content-between align-items-center">
            <h3 class="ms-4">Email Configurations</h3>
            <router-link style="background-color: #0CAF60; color: white;" class="btn me-3"
                to="/config">Create</router-link>
        </div>

        <table class="table table-bordered table-stripped">
            <thead>
                <tr>
                    <th>Sl. No</th>
                    <th>Port</th>
                    <th>Host</th>
                    <th>Email</th>
                    <th>Password</th>
                    <th>Action</th>
                    <th>Email pagination</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(config, index) in configs" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ config.incoming_port }}</td>
                    <td>{{ config.host }}</td>
                    <td>
                        <!-- Display paginated emails -->
                        <div v-for="(user, userIndex) in getPaginatedUsers(index)" :key="userIndex"
                            style="height: 40px; border-bottom: 1px solid #ddd5d5;">
                            {{ user.email }}
                        </div>
                    </td>
                    <td>
                        <!-- Display paginated passwords -->
                        <div v-for="(user, userIndex) in getPaginatedUsers(index)" :key="userIndex"
                            style="height: 40px; border-bottom: 1px solid #ddd5d5;">
                            <span v-if="!showPassword[index][userIndex]">*****</span>
                            <span v-else>{{ user.password }}</span>
                            <button @click="togglePassword(index, userIndex)">
                                {{ showPassword[index][userIndex] ? 'hide' : 'show' }}
                            </button>
                        </div>
                    </td>
                    <td>
                        <!-- Edit and Delete Buttons with Icons -->
                        <button class="ms-3" @click="editUser(config.id)">
                            <PencilIcon style="width: 21px;" />
                        </button>
                        <button class="ms-3" @click="deleteUser(config.id)">
                            <TrashIcon style="width: 21px;" />
                        </button>
                    </td>
                    <td>
                        <!-- Pagination controls for usernames -->
                        <div class="pagination">
                            <button @click="setPage(index, (currentPageByConfig[index] || 1) - 1)"
                                :disabled="(currentPageByConfig[index] || 1) === 1">Previous</button>
                            <span>Page {{ currentPageByConfig[index] || 1 }} of
                                {{
                                    Math.ceil(parseJson(config.username).length / itemsPerPage)
                                }}
                            </span>
                            <button @click="setPage(index, (currentPageByConfig[index] || 1) + 1)"
                                :disabled="(currentPageByConfig[index] || 1) === Math.ceil(parseJson(config.username).length / itemsPerPage)">Next</button>
                        </div>
                    </td>
                </tr>
                <tr v-if="configs.length === 0">
                    <td colspan="5" class="text-center">No data available</td>
                </tr>
            </tbody>
        </table>

    </div>
</template>

<script>
import { reactive } from 'vue';
import { PencilIcon, TrashIcon } from "@heroicons/vue/24/outline";
import { apiUrl } from '@/globalVariable';
import axios from 'axios';
import toastr from "toastr";

export default {
    data() {
        return {
            configs: [],
            showPassword: [],
            currentPageByConfig: reactive({}), // Tracks current page for each configuration
            itemsPerPage: 10,
        };
    },

    components: {
        PencilIcon,
        TrashIcon
    },

    mounted() {
        this.fetchConfigurations();
    },
    methods: {
        getPaginatedUsers(configIndex) {
            const config = this.configs[configIndex];
            const users = this.parseJson(config.username);
            const currentPage = this.currentPageByConfig[configIndex] || 1;
            const startIndex = (currentPage - 1) * this.itemsPerPage;
            const endIndex = startIndex + this.itemsPerPage;
            return users.slice(startIndex, endIndex); // Return only the current page's users
        },

        // Set the current page for a config
        setPage(configIndex, page) {
            const users = this.parseJson(this.configs[configIndex].username);
            const totalPages = Math.ceil(users.length / this.itemsPerPage);
            if (page >= 1 && page <= totalPages) {
                this.currentPageByConfig[configIndex] = page; // Update the current page directly
            }
        },

        async fetchConfigurations() {
            try {
                const response = await axios.get(`${apiUrl}all-config`);
                this.configs = response.data.config;

                this.showPassword = this.configs.map((config) => {
                    const parsedUsers = this.parseJson(config.username);
                    return parsedUsers.map(() => false);
                });

                // Initialize pagination for each config
                this.configs.forEach((_, index) => {
                    this.currentPageByConfig[index] = 1; // Set initial page to 1
                });
            } catch (error) {
                console.error('Error fetching configurations:', error);
            }
        },

        parseJson(jsonString) {
            try {
                return JSON.parse(jsonString);
            } catch {
                return [];
            }
        },

        togglePassword(configIndex, userIndex) {
            this.showPassword[configIndex][userIndex] = !this.showPassword[configIndex][userIndex];
        },

        editUser(configId) {
            this.$router.push(`/configEdit/${configId}`);
        },

        // Method for deleting the configuration
        async deleteUser(configId) {
            try {
                await axios.delete(`${apiUrl}email-config/${configId}`);
                // this.$emit("deleted", configId); 
                toastr.success('Deleted Successfully.')
                this.fetchConfigurations();
            } catch (error) {
                console.error("Error deleting the config:", error);
            }
        }
    },
};
</script>

<style scoped>
.pagination {
    margin-top: 10px;
    display: flex;
    justify-content: center;
    gap: 10px;
}

.pagination button {
    padding: 5px 10px;
    border: 1px solid #ddd;
    background-color: #f9f9f9;
    cursor: pointer;
}

.pagination button:disabled {
    background-color: #eaeaea;
    cursor: not-allowed;
}

.table {
    width: 98%;
    border-collapse: collapse;
    margin: 20px;
}

.table th,
.table td {
    padding: 8px;
    text-align: left;
    border: 1px solid #ddd;
}

.table th {
    background-color: #f4f4f4;
}

.text-center {
    text-align: center;
}

.showHideButton {
    padding: 2px 12px;
    border: none;
    border-radius: 5px;
    margin-left: 5px;
    margin-top: 5px;
    cursor: pointer;
}
</style>